<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <h1 class="title is-1">Hot Wings Of Destiny</h1>
        <div class="container">
          <p>
            I feel it coming, the course is set </br>
            A challenge that I must accept</br>
            I must become something more than a man</br>
            I must become a champion</br>
          </p>
          <p>
            Removal of bones, gnawing of flesh</br>
            Why I was created, what I do best</br>
            Hot wings, my destiny, they don't stand a chance</br>
            Feasting on wings until I shit my pants</br>
          </p>
          <p>
            Some people say it's a gluttonous thing</br>
            To live your life in pursuit of the wing</br>
            I was born a warrior, to conquer this hell</br>
            Give me the wings, you keep the kale</br>
          </p>
          <p>
            Removal of bones, gnawing of flesh</br>
            Why I was created, what I do best</br>
            Hot wings, my destiny, sauce burns my eyes</br>
            Feasting on wings until I fucking die</br>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ContactForm from "./ContactForm";
export default {
  name: "Home",
  data() {
    return {};
  },
  components: {
    ContactForm
  }
};
</script>

<style scoped>
.hero {
  text-align: center;
}
.align-left {
  text-align: left;
}
p {
  margin: 1rem auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Hwod.vue